import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const Page = lazy(() => import('@/modules/posta/PostaSpravaPage').then((m) => ({ default: m.PostaSpravaPage })));

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/posta/sprava',
  validateSearch: (input: Record<string, unknown>): { nastroj?: 'spolecnosti' | 'historie' } =>
    input.nastroj === 'historie' ? { nastroj: 'historie' } : {},
  component: () => <Suspense fallback={null}><Page /></Suspense>,
});
